import styled from "styled-components/macro";


export const ImgPvc = styled.img`
  grid-area: pvc;
`;